import Metadata from '@/core/components/metadata/Metadata.tsx'
import HomeLayout from '@/core/layouts/HomeLayout.tsx'

const HomePage = () => {
  return (
    <>
      <Metadata>
        <title>Homepage</title>
      </Metadata>
      <HomeLayout />
    </>
  )
}

export default HomePage
